import { Route, Switch } from 'react-router-dom';

import { useEvent } from './Common/EventProvider';
import BuyRegistrationPage from './Resale/BuyRegistrationPage';
import CheckoutPage from './Checkout/CheckoutPage';
import CheckoutProvider from './Checkout/CheckoutProvider';
import CheckoutSummaryProvider from './Checkout/CheckoutSummaryProvider';
import ErrorBoundary from './Checkout/ErrorBoundary';
import EventNotFound from '../common/EventNotFound';
import InterestPage from './Checkout/InterestPage';
import NetworkError from '../common/NetworkError';
import OverviewPage from './Resale/OverviewPage';
import SuccessPage from './Checkout/Success/SuccessPage';
import WaitlistPage from './Checkout/WaitlistPage';
import WidgetContainer from './Common/WidgetContainer';

const Main = () => {
  const { event, error } = useEvent();

  if ((error?.graphQLErrors?.[0]?.extensions?.validation as any)?.event?.exists) {
    return <EventNotFound />;
  }

  if (error) {
    return <NetworkError />;
  }

  return (
    <ErrorBoundary redirect={event?.checkout_url}>
      <WidgetContainer showRegisterButton={!!event}>
        <Route
          path="/:eventId/:step?"
          render={({ match: { params: { step } } }) => (
            <CheckoutSummaryProvider>
              <CheckoutProvider
                step={step as any}
                render={(props) => (
                  <Switch>
                    <Route
                      path="/:eventId/waitlist/:ticketId"
                      render={({ match: { params: { ticketId } } }) => (
                        <WaitlistPage ticketId={ticketId} />
                      )}
                    />
                    <Route path="/:eventId/interest">
                      <InterestPage />
                    </Route>
                    <Route path="/:eventId/thank-you">
                      <SuccessPage />
                    </Route>
                    <Route
                      path="/:eventId/resale/:registrationId/:resaleToken"
                      render={({ match: { params: { registrationId, resaleToken } } }) => (
                        <BuyRegistrationPage
                          registrationId={registrationId}
                          resaleToken={resaleToken}
                        />
                      )}
                    />
                    <Route path="/:eventId/resale">
                      <OverviewPage />
                    </Route>
                    <Route path="/:eventId/:step?">
                      <CheckoutPage {...props} />
                    </Route>
                  </Switch>
                )}
              />
            </CheckoutSummaryProvider>
          )}
        />
      </WidgetContainer>
    </ErrorBoundary>
  );
};

export default Main;
